import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenesysCloudPlatformApiService } from '../../common/services/genesys-cloud-platform-api.service';
import { Contact } from '../models/contact.model';

@Injectable({
  providedIn: 'root'
})
export class ExternalContactApiService {
  static readonly ContactsPath = 'api/v2/externalcontacts/contacts';

  constructor(private readonly api: GenesysCloudPlatformApiService) {
  }

  getContact$(contactId: string): Observable<Contact> {
    const url = `${ExternalContactApiService.ContactsPath}/${contactId}`;
    return this.api.get$<Contact>(url);
  }
}
